/* 🤖 this file was generated by svg-to-ts */
export const matIconAutoAwesomeMotion: {
  name: 'auto-awesome-motion';
  data: string;
} = {
  name: 'auto-awesome-motion',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14 2H4c-1.1 0-2 .9-2 2v10h2V4h10V2zm4 4H8c-1.1 0-2 .9-2 2v10h2V8h10V6zm2 4h-8c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2zm0 10h-8v-8h8v8z"/></svg>`
};
